<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-9">The Ex I</p>
<p class="BT-Opener"><span class="Drop CharOverride-9">H</span>e still loves his ex-girlfriend, and they’re still close friends. She’s elegant and clever. She was at the top of her class in classics in school, they both know Latin, and they’re both well-read; they toss Derrida quotes around like it’s nothing. The other day, he asked me to meet him at a coffeehouse, so it was more than a little strange that he was sitting with her when I arrived. I felt humiliated, and I wanted to leave, to turn around and walk straight out, to disappear, but they’d already spotted me and I had to sit with them. It was one of the most uncomfortable afternoons of my life. I was stressed, sweating like a pig, and I got this weird tremor. They were so relaxed together, and so much smarter than me. They talked about movies I hadn’t seen, and they went on and on about things I hadn’t ever thought about. The Ex tried to bring me into the conversation by explaining, among other things, what a <span class="CharOverride-6">strawberry milkshake</span> was—it’s when a man cums on a woman’s face and punches her in the nose, giving her a nosebleed. <span class="CharOverride-6">Snowballing</span>,<span class="CharOverride-6"> </span>she went on, is when a man cums in a woman’s mouth and she spits it into his mouth. He’s told me about sex with her—how nice it was, how talented she is at blow jobs. I’m pretty bad at them; I just gag. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802157409-8.vue?1a0c28bd